const qtyInput = {
  init() {
    var cartUpdateBtn = document.querySelector('[name="update_cart"]');
    var buttons = document.querySelectorAll('form .quantity-change');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function(e) {
        e.preventDefault();
        if ( cartUpdateBtn ) {
          cartUpdateBtn.disabled = false;
        }
      });
    }
  },
};

export default qtyInput;



// WEBPACK FOOTER //
// ./scripts/modules/product-quantity-change.js